<mat-form-field [style.width.px]=110 [style.marginRight.px]=10 appearance="fill">
    <mat-label>Warehouse</mat-label>
    <mat-select #selector [formControl]="selectorFormControl" (touched)="onTouched()">
        <mat-option *ngFor="let warehouse of warehouses" [value]="warehouse.id">{{warehouse.id}} -
            {{warehouse.descr}}
        </mat-option>
    </mat-select>
</mat-form-field>